import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetPaymentGatewayApi = () => api.get('PaymentGateway/GetActivePaymentGatways');
export const DepositAmountApi = (data, headers) => api.post('wallet/create-deposit-request', data, headers);
export const GetPaymentGatewayByIdApi = () => api.get('bankdetails/get-active-bank-details');
export const GetAllDepositRequestApi = (params) => api.get(`wallet/get-all-deposit-request?${qs(params)}`);
export const GetCurrentCurrencyRateApi = () => api.get('currency/get-current-currency-rate');
export const getBankDataApi = () => api.get(`bankdetails/get-active-bank-details`);
export const DeletePendingDepositRequest= (RequestID) => api.delete(`wallet/delete-deposit-request/${RequestID}`);

